import { filter, map as mapCapped, reduce } from 'lodash/fp';
import React from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

const map = mapCapped.convert({ cap: false });

const SingleSelection = ({ label, values, current, setter }) => {
  const selectionChange = (e) => setter(e.target.value);
  return (
    <RadioGroup
      aria-label={label}
      name={label}
      value={current}
      onChange={selectionChange}
    >
      {values?.length > 0
        ? map(
            (value, index) => (
              <FormControlLabel
                key={index}
                value={value}
                control={<Radio />}
                label={value}
              />
            ),
            values,
          )
        : 'N/A'}
    </RadioGroup>
  );
};

const MultiSelection = ({ label, values, current, setter }) => {
  const toggle = (add, value, values) =>
    add ? [...values, value] : filter((x) => x !== value, values);

  const selectionChange = (value) => (e) => {
    setter(toggle(e.target.checked, value, current));
  };

  return (
    <FormGroup aria-label={label} name={label}>
      {values?.length > 0
        ? map(
            (value, index) => (
              <FormControlLabel
                key={index}
                label={value}
                control={
                  <Checkbox
                    checked={current.includes(value)}
                    onChange={selectionChange(value)}
                  />
                }
              />
            ),
            values,
          )
        : 'N/A'}
    </FormGroup>
  );
};

const Aspect = ({
  aspect: { label, name, values, current, selectionType },
  setParams,
}) => {
  const setter = (selectedValues) => setParams(name, selectedValues);

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{label}</FormLabel>
      {selectionType === 'single' ? (
        <SingleSelection
          label={label}
          values={values}
          current={current}
          setter={setter}
        />
      ) : (
        <MultiSelection
          label={label}
          values={values}
          current={current}
          setter={setter}
        />
      )}
    </FormControl>
  );
};

const Aspects = ({ aspects, handleAspectsChange }) => {
  const aspectsCurrent = reduce(
    (acc, { name, current }) => ({ ...acc, [name]: current }),
    {},
    aspects,
  );
  
  const setParams = (name, selectedValues) =>handleAspectsChange({ ...aspectsCurrent, [name]: selectedValues });

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
      }}
    >
      {map(
        (aspect, index) => (
          <Aspect aspect={aspect} key={index} setParams={setParams} />
        ),
        aspects,
      )}
    </Box>
  );
};

export { Aspects };
